import { isGE } from '../Device'
import ScrollListWithPagination from './ScrollListWithPagination'
import ScrollList from './ScrollList'

export default isGE() ? ScrollListWithPagination : ScrollList
